import enquire from 'enquire-js';
import { tns } from 'tiny-slider/src/tiny-slider.module';

/**
 * Initialize slider on mobile, destroy it when we go
 * back to desktop width
 */

const init = () => {
	//const columnSlider = document.querySelectorAll('.wp-block-csccanada-columns');
	const aSpotSlider = document.querySelector('.a-spot-carousel');

	if (!aSpotSlider) {
		return;
	}

	const slider = tns({
		container: aSpotSlider,
		slideBy: 'page',
		nav: true,
		controlsText: ['Previous slide', 'Next Slide']
	});
};

init();
